import { SelectField, LoadingWrapper } from "ui";
import { Typography, Grid } from "@mui/material";
import { Form, Field } from "react-final-form";
import { LoadingButton } from "@mui/lab";
import { format, addDays } from "date-fns";
import { useSlideInContext } from "../SlideInProvider";
export type AddSubscriptionPayload = {
    subscriptionId: string
}
export type AddSubscriptionProps = {
    subscriptions: any[],
    addNewSubscription: (data: AddSubscriptionPayload) => Promise<void>,
    loading: boolean
}

function AddSubscription(props: AddSubscriptionProps) {
    const { toggleDrawer } = useSlideInContext()
    const handleSubmit = async (values: AddSubscriptionPayload) => {
        await props.addNewSubscription(values)
        toggleDrawer()
    }
    return (
        <LoadingWrapper loading={props.loading}>
            <div>
                <Form initialValues={{ subscriptionId: "" }}
                    onSubmit={handleSubmit}
                    render={({ form, submitting, submitError, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    {/* <Typography>Select a subscription</Typography> */}
                                </Grid>
                                <Grid size={12}>
                                    <Field name="subscriptionId" render={(fieldProps) => (
                                        <SelectField options={props.subscriptions} {...fieldProps}
                                            label={"Select a subscription"}
                                            required
                                        // placeholder={"PICKS IS THE PLACEHOLDER"}
                                        />
                                    )} />
                                </Grid>
                                {/* {subscription?.length > 0 ?
                                    <> */}
                                <Grid size={12}>
                                    <Typography>Subscription Expires on {format(addDays(new Date(), 364), "MM/dd/yyyy")}</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <LoadingButton variant="contained" type="submit">
                                        Submit
                                    </LoadingButton>
                                </Grid>
                                {/* </> : <></>} */}

                            </Grid>
                        </form>
                    )}
                />
            </div>
        </LoadingWrapper>
    )
}

export default AddSubscription